/**
 * Where the Place button shows: the Analysis and Loader HUDs of the full
 * profile. Operations is the live picture and the slim noaa-core instance has
 * no what-if placement. The mode comes from the route (/analysis, /loader, ...).
 */
import { MODES, type Mode } from '@/state/store';
import type { LoaderProfile } from '../store';

export const PLACE_MODES: readonly Mode[] = ['analysis', 'loader'];

export function placeButtonVisible(mode: Mode | null, profile: LoaderProfile): boolean {
  return mode !== null && PLACE_MODES.includes(mode) && profile !== 'noaa-core';
}

/** The shell mode a pathname belongs to: its first segment when that is a mode, else null (/twin/..., /admin). */
export function modeFromPathname(pathname: string): Mode | null {
  const first = pathname.split('/').find((part) => part !== '') ?? '';
  return (MODES as readonly string[]).includes(first) ? (first as Mode) : null;
}
